var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('database-picker',{attrs:{"return-id":_vm.returnId,"rules":_vm.rules,"color":_vm.color,"label":"Teslim Edilen Seçiniz","action":"/api/v1/tebligat-teslim-tipi"},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }